(function() {
  'use strict';

  var preloadedProductMenuSources = [];
  var productsMenuPreloadTimer = null;

  function getSourceFromSrcset(srcset) {
    if (!srcset) return '';

    return srcset.split(',')[0].trim().split(/\s+/)[0];
  }

  function addProductsMenuPreloadLink(source) {
    if (!source || document.querySelector('link[rel="preload"][href="' + source.replace(/"/g, '\\"') + '"]')) return;

    var preloadLink = document.createElement('link');
    preloadLink.rel = 'preload';
    preloadLink.as = 'image';
    preloadLink.href = source;
    document.head.appendChild(preloadLink);
  }

  function preloadProductsMenuImages() {
    var sources = [];

    document.querySelectorAll('.products-menu img, .products-menu-mobile img').forEach(function(image) {
      var currentSource = image.currentSrc || image.getAttribute('src');
      var sourceSet = image.closest('picture') && image.closest('picture').querySelector('source[media]');

      if (sourceSet && window.matchMedia(sourceSet.getAttribute('media')).matches) {
        currentSource = getSourceFromSrcset(sourceSet.getAttribute('srcset')) || currentSource;
      }

      if (currentSource && sources.indexOf(currentSource) === -1 && preloadedProductMenuSources.indexOf(currentSource) === -1) {
        sources.push(currentSource);
      }
    });

    sources.forEach(function(source) {
      addProductsMenuPreloadLink(source);

      var preloadImage = new Image();
      preloadImage.decoding = 'async';
      preloadImage.fetchPriority = 'low';
      preloadImage.src = source;
      preloadedProductMenuSources.push(source);
    });
  }

  function queueProductsMenuImagePreload(delay) {
    window.clearTimeout(productsMenuPreloadTimer);
    productsMenuPreloadTimer = window.setTimeout(preloadProductsMenuImages, delay || 0);
  }

  function handleProductsMenuWarmup(event) {
    if (!event.target.closest('.navigation__item--products-dropdown, .products-menu-mobile, .products-menu-mobile__toggle')) return;

    queueProductsMenuImagePreload(0);
    document.removeEventListener('pointerover', handleProductsMenuWarmup);
    document.removeEventListener('touchstart', handleProductsMenuWarmup);
    document.removeEventListener('focusin', handleProductsMenuWarmup);
  }

  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('.products-menu-mobile__toggle');

    if (!toggle) return;

    queueProductsMenuImagePreload(0);

    var menu = toggle.closest('.products-menu-mobile');
    var target = toggle.getAttribute('data-target');
    var content = menu.querySelector('.products-menu-mobile__content[data-panel="' + target + '"]');

    if (!menu || !target || !content) return;

    event.preventDefault();
    event.stopPropagation();

    var isOpen = content.classList.contains('is-active');
    var allToggles = menu.querySelectorAll('.products-menu-mobile__toggle');
    var allContents = menu.querySelectorAll('.products-menu-mobile__content');

    allToggles.forEach(function(otherToggle) {
      otherToggle.classList.remove('is-active');
      otherToggle.setAttribute('aria-expanded', 'false');
    });

    allContents.forEach(function(otherContent) {
      otherContent.classList.remove('is-active');
    });

    if (!isOpen) {
      toggle.classList.add('is-active');
      toggle.setAttribute('aria-expanded', 'true');
      content.classList.add('is-active');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      queueProductsMenuImagePreload(150);
    });
  } else {
    queueProductsMenuImagePreload(150);
  }

  document.addEventListener('pointerover', handleProductsMenuWarmup);
  document.addEventListener('touchstart', handleProductsMenuWarmup, { passive: true });
  document.addEventListener('focusin', handleProductsMenuWarmup);
})();

(function() {
  'use strict';

  function updateProductsMenuAlignment() {
    var logoNodes = Array.prototype.slice.call(document.querySelectorAll('.logo img, .logo a, .logo__link, .logo-area__middle a'));
    var logoNode = logoNodes.find(function(node) {
      var rect = node.getBoundingClientRect();
      var styles = window.getComputedStyle(node);

      return rect.width > 0
        && rect.height > 0
        && styles.display !== 'none'
        && styles.visibility !== 'hidden'
        && styles.opacity !== '0';
    });
    var productLinks = Array.prototype.slice.call(document.querySelectorAll('.navigation .navigation__tier-1 > .navigation__item > .navigation__link'));
    var productsLink = productLinks.find(function(navigationLink) {
      var rect = navigationLink.getBoundingClientRect();
      var styles = window.getComputedStyle(navigationLink);

      return navigationLink.textContent.trim().toLowerCase() === 'products'
        && rect.width > 0
        && rect.height > 0
        && styles.display !== 'none'
        && styles.visibility !== 'hidden';
    });

    if (!productsLink && !logoNode) return;

    var productTextLeft = null;
    if (productsLink) {
      var linkRect = productsLink.getBoundingClientRect();
      productTextLeft = linkRect.left;
    }

    var logoLeft = null;
    if (logoNode) {
      logoLeft = logoNode.getBoundingClientRect().left;
    }

    document.querySelectorAll('.navigation__item--products-dropdown .products-menu').forEach(function(productsMenu) {
      var menuRect = productsMenu.getBoundingClientRect();

      if (productTextLeft !== null) {
        productsMenu.style.setProperty('--products-menu-measured-product-left', Math.round(productTextLeft - menuRect.left) + 'px');
      }

      if (logoLeft !== null) {
        productsMenu.style.setProperty('--products-menu-measured-logo-left', Math.round(logoLeft - menuRect.left) + 'px');
      }
    });
  }

  function queueProductsMenuAlignment() {
    window.requestAnimationFrame(updateProductsMenuAlignment);
  }

  window.addEventListener('load', queueProductsMenuAlignment);
  window.addEventListener('resize', queueProductsMenuAlignment);
  document.addEventListener('shopify:section:load', queueProductsMenuAlignment);
  queueProductsMenuAlignment();
})();
